import { createClient } from "@supabase/supabase-js";

/**
 * Tarayıcı tarafı Supabase istemcisi (CLAUDE.md §8.1).
 * Yalnızca ANON/publishable key kullanılır — RLS koruması esastır.
 * Service role key ASLA frontend'de bulunmaz.
 */
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Faz 0 iskeleti: .env doldurulmadan da uygulama yüklenebilsin diye uyarı.
  console.warn(
    "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY tanımlı değil. .env dosyasını doldurun.",
  );
}

export const supabase = createClient(url ?? "", anonKey ?? "", {
  auth: { persistSession: true, autoRefreshToken: true },
});
